const junoVideo = {
  selection: {
    new: "New Model",
    popularModel: "Popular",
    referenceModel: "Reference",
    longModel: "Long Video",
    highQualityModel: "High Quality",
    lowCostModel: "Low Cost",
    highPrecisionModel: "High Precision",
    cameraControl: "Camera Control",
    trending: "Trending",
    fastModel: "Fast",
    costEffective: "Cost Effective",
    popularLipSync: "Popular Lip Sync",
    imageToVideo: "Image to Video",
    videoEdit: "Video Edit",
    upscale: "Upscale",
    lipsync: "Lip Sync",
  },
  title: "VIDEO GENERATOR",
  caution: "Due to Google's pricing, the cost of VEO2 is extremely high. Please use with caution.",
  menu: {
    t2v: "Text to Video",
    i2v: "Image to Video",
    v2v: "Video to Video",
    library: "Library",
    upscale: "Upscale",
    lipsync: "Lip Sync",
    reframe: "Reframe",
  },
  ai: {
    select: "Please select an AI model",
    model: "Model",
    runway: {
      title: "RunwayML",
      description:
        "[Fast] Simplifies the video production process using AI and machine learning, catering to both professionals and beginners.",
      model: {
        GEN3_ALPHA_TURBO: "Gen3 Alpha Turbo",
        GEN3_ALPHA_TURBO_description: "Runway's fastest model. Optimal for quick iterations and previews.",
        GEN4_TURBO: "Gen4 Turbo",
        GEN4_TURBO_description:
          "Runway's latest Gen4 model offering higher quality video generation with improved consistency and realism.",
      },
    },
    kling: {
      title: "KLING AI",
      description:
        "[Slow] KLING AI generates realistic and natural-motion videos using advanced physics simulation and 3D technology.",
      model: {
        V1_0_STANDARD: "v1.0 Standard",
        V1_6_STANDARD: "v1.6 Standard",
        V1_0_PRO: "v1.0 Pro",
        V1_5_PRO: "v1.5 Pro",
        V1_6_PRO: "v1.6 Pro",
        V1_6_STANDARD_ELEMENTS: "v1.6 Standard Elements",
        V1_6_PRO_ELEMENTS: "v1.6 Pro Elements",
        V2_MASTER: "v2.0 Master",
        V2_1_STANDARD: "v2.1 Standard",
        V2_1_PRO: "v2.1 Pro",
        V2_1_MASTER: "v2.1 Master",
        V1_0_STANDARD_description:
          "KLING's initial basic model. Generates videos at 720p resolution up to 5 seconds with physics-based natural motion and fundamental video generation capabilities.",
        V1_6_STANDARD_description:
          "KLING's 1.6 generation standard model. Supports 720p resolution video generation up to 10 seconds with significantly improved quality, realism, and enhanced prompt understanding.",
        V1_0_PRO_description:
          "Initial KLING pro model. Generates higher quality and longer duration videos with more natural movements and detailed expressions for professional video production.",
        V1_5_PRO_description:
          "Full HD 1080p compatible 1.5 generation pro model. Features Motion Brush function (individual motion specification for up to 6 elements) and Camera Movement capabilities with significantly improved quality and realism.",
        V1_6_PRO_description:
          "Full HD 1080p compatible latest pro model. Achieves the highest level of video quality as of December 2024, providing complex physics simulation and natural motion as the most advanced KLING model.",
        V1_6_STANDARD_ELEMENTS_description:
          "Standard Elements model supporting simultaneous input of 3 images for complex scene generation. Supports advanced video production combining multiple viewpoints and elements at 720p resolution.",
        V1_6_PRO_ELEMENTS_description:
          "Pro Elements model supporting simultaneous input of 3 images for high-quality complex scene generation. Top-tier Elements series model enabling detailed video production at 1080p resolution.",
        V2_MASTER_description:
          "KLING's 2nd generation master model. Achieves further quality improvement and generation efficiency enhancement from v1.6 with more advanced physics simulation and natural motion.",
        V2_1_STANDARD_description:
          "Latest KLING v2.1 standard model. Achieves fast generation and excellent quality with improved processing speed from v2.0 for easier high-quality video generation.",
        V2_1_PRO_description:
          "Latest KLING v2.1 pro model. Generates higher quality and more detailed videos than v2.1 Standard, providing the highest level of video quality suitable for professional use.",
        V2_1_MASTER_description:
          "Latest KLING v2.1 master model. Top-tier KLING series model providing the highest quality and precision, achieving cinema-level quality as the most advanced video generation model.",
      },
    },
    luma: {
      title: "Luma",
      description:
        "[Fast] Luma Ray is an AI model that generates high-quality and realistic videos from text or images.",
      model: {
        V1_5: "Ray 1.5",
        RAY_1_6: "Ray 1.6",
        RAY_2: "RAY 2",
        RAY_2_1080P: "RAY 2 1080P",
        RAY_2_4K: "RAY 2 4K",
        V1_5_description:
          "Dream Machine's initial stable model. Well-balanced quality and generation speed, generating 120-frame videos at 24fps×5 seconds with basic video generation capabilities.",
        RAY_1_6_description:
          "Improved version of Ray featuring camera motion capabilities. Supports camera work instructions (zoom, pan, etc.) via text input with significant speed improvements for short-time video generation.",
        RAY_2_description:
          "Revolutionary model with 10x computational processing power of Ray1.6. Achieves faster and more natural motion, ultra-realistic detail expression, and logical event progression with significantly improved video generation success rate.",
        RAY_2_1080P_description:
          "RAY 2's 1080p resolution version. Features 4K upscaling capabilities and supports up to 10 seconds of video generation for professional-quality video production.",
        RAY_2_4K_description:
          "RAY 2's 4K resolution version. Capable of maximum quality video generation optimal for large screen display and high-definition video production with ultimate quality and detail.",
        RAY_2_FLASH: "RAY 2 Flash",
        RAY_2_FLASH_description:
          "High-speed version of RAY 2. Achieves significant speed improvement while maintaining quality, ideal for efficient video generation and high-volume content creation.",
        RAY_2_FLASH_1080P: "RAY 2 Flash 1080P",
        RAY_2_FLASH_1080P_description:
          "RAY 2 Flash's 1080p resolution version. Combines fast generation with high image quality, enabling efficient high-quality video production.",
        RAY_2_FLASH_4K: "RAY 2 Flash 4K",
        RAY_2_FLASH_4K_description:
          "RAY 2 Flash's 4K resolution version. Capable of ultra-high definition output while maintaining fast generation, a revolutionary model balancing speed and maximum image quality.",
        RAY_2_REFRAME: "RAY 2 Reframe",
        RAY_2_REFRAME_description:
          "RAY 2 model specialized for aspect ratio changes. Naturally converts existing video aspect ratios, streamlining content creation for different platforms.",
        RAY_2_FLASH_REFRAME: "RAY 2 Flash Reframe",
        RAY_2_FLASH_REFRAME_description:
          "Fast aspect ratio change model. Efficiently optimizes videos for multiple SNS platforms as a practical reframing tool.",
      },
    },
    hailuo: {
      title: "Minimax",
      description:
        "[Slow] Hailuo AI/Minimax excels in generating high-quality videos with accurate human motion reproduction.",
      model: {
        MINI_MAX: "VIDEO-01",
        MINI_MAX_LIVE: "VIDEO-01-LIVE",
        MINI_MAX_REF: "VIDEO-01-SUBJECT-REFFRENCE",
        MINI_MAX_DIRECTOR: "VIDEO-01-DIRECTOR",
        MINI_MAX_description:
          "MiniMax's standard video generation model. Generates high-quality videos up to 6 seconds at 720p resolution and 25fps, supporting both text and image input with accurate human motion reproduction.",
        MINI_MAX_LIVE_description:
          "Model optimized for 2D animation style. Specializes in naturally animating anime characters and 2D illustrations, ideal for animation production.",
        MINI_MAX_REF_description:
          "Model with subject reference functionality. Capable of generating videos while maintaining consistency of specific characters or people, supporting continuous video production with maintained character settings.",
        MINI_MAX_DIRECTOR_description:
          "Advanced model with detailed camera control capabilities. Supports cinematic camera work, angle changes, and complex direction instructions for professional video production.",
      },
    },
    haiper: {
      title: "Haiper AI",
      description: "[Slow] Haiper AI excels in naturally reproducing Japanese faces and poses.",
      model: {
        V2_0: "Haiper V2.0",
        V2_5: "Haiper V2.5",
        V2_0_description:
          "Haiper's 2nd generation model. Features newly adopted deep learning algorithms with more natural human movements and expressions. Fixed 6-second video generation with template functionality.",
        V2_5_description:
          "Improved version of V2.0 with evolved smoother and more natural movements. Demonstrates excellent performance particularly in reproducing natural expressions and poses of Asian faces including Japanese.",
      },
    },
    pixverse: {
      title: "PixVerse",
      description:
        "[Fast] PixVerse is a high-quality video generation AI that creates natural motion videos from text or images.",
      model: {
        V3_5: "V3.5",
        V3_5_1080P: "V3.5 1080P",
        V3_5_FAST: "V3.5 Performance",
        V3_5_TRANSITION: "V3.5 Transition",
        V3_5_TRANSITION_1080P: "V3.5 Transition 1080P",
        V4: "V4",
        V4_1080P: "V4 1080P",
        V4_FAST: "V4 Performance",
        V4_5: "V4.5",
        V4_5_1080P: "V4.5 1080P",
        V4_5_FAST: "V4.5 Performance",
        V4_5_TRANSITION: "V4.5 Transition",
        V4_5_TRANSITION_1080P: "V4.5 Transition 1080P",
        V3_5_description:
          "720p resolution high-quality video generation model. Achieves ultra-fast generation under 10 seconds with enhanced anime style and Start/End Frame function for controlling video opening and closing scenes.",
        V3_5_1080P_description:
          "V3.5's 1080p resolution version. Capable of higher quality video output suitable for professional use with clear and detailed video generation.",
        V3_5_FAST_description:
          "V3.5's high-speed optimized version. Specialized for action scenes and high-movement situations, capable of expressing dynamic and active movements efficiently.",
        V3_5_TRANSITION_description:
          "Generates natural transition videos between two images. Achieves smooth image transitions at 720p resolution, ideal for storytelling and presentations.",
        V3_5_TRANSITION_1080P_description:
          "V3.5 Transition's 1080p high-quality version. Generates clearer and more detailed image transition videos for professional video production.",
        V4_description:
          "PixVerse's latest 720p model. Achieves significant quality improvement from V3.5 with newly added audio synchronization functionality and more natural, smooth motion generation.",
        V4_1080P_description:
          "V4's 1080p resolution version. Enables detailed video expression at high resolution, achieving professional-level video production combined with audio functionality.",
        V4_FAST_description:
          "V4's high-speed processing optimized version. Significantly reduces processing time at 720p resolution while maintaining V4 quality for efficient video generation.",
        V4_5_description:
          "PixVerse's latest 720p video generation model. Features over 20 cinematic lens effects and multi-image fusion functionality, achieving Hollywood-level video expression.",
        V4_5_1080P_description:
          "V4.5's 1080p high-quality version. Combines cinematic-quality lens control with high resolution, optimal for professional video production.",
        V4_5_FAST_description:
          "V4.5's high-speed processing version. Generates cinematic-quality features at 720p resolution with optimized balance of speed and quality for business use.",
        V4_5_TRANSITION_description:
          "Smooth transition between two images with V4.5 quality. Achieves cinema-level image transition effects at 720p resolution.",
        V4_5_TRANSITION_1080P_description:
          "V4.5 Transition's 1080p version. Generates high-resolution image transition videos using cinematic-quality lens effects, providing the highest level of video expression.",
        V4_T2V_description:
          "V4 model specialized for text-to-video generation. Optimized text prompt understanding at 720p resolution for more accurate video generation.",
        V4_T2V_1080P_description:
          "Text generation specialized V4 model's 1080p version. Capable of generating high-quality videos faithfully reproducing text prompts at high resolution.",
        V4_T2V_FAST_description:
          "V4 high-speed version specialized for text generation. Efficiently executes text prompt-to-video generation at 720p resolution.",
      },
      style: {
        default: "Default",
        anime: "Anime",
        "3d_animation": "3D Animation",
        clay: "Clay Art",
        comic: "Comic",
        cyberpunk: "Cyberpunk",
      },
    },
    vidu: {
      title: "Vidu",
      description: "[Fast] Vidu is an AI model that generates high-quality videos from text or images.",
      model: {
        VIDU_2_0_720P: "Vidu v2.0 720P",
        VIDU_2_0_1080P: "Vidu v2.0 1080P",
        VIDU_2_0_REF_720P: "Vidu v2.0 Reference 720P",
        VIDU_2_0_START_END_720P: "Vidu v2.0 Start-End 720P",
        VIDU_2_0_START_END_1080P: "Vidu v2.0 Start-End 1080P",
        VIDU_Q1: "Vidu Q1",
        VIDU_Q1_START_END: "Vidu Q1 Start-End",
        VIDU_2_0_720P_description:
          "Vidu's 2nd generation 720p standard model. Achieves fast generation and stable quality for efficient video production, supporting both text and image inputs.",
        VIDU_2_0_1080P_description:
          "Vidu v2.0's 1080p high-quality version. Capable of more detailed and clear video output suitable for professional use.",
        VIDU_2_0_REF_720P_description:
          "Can generate ideal videos by combining up to 3 reference images. Advanced functionality supporting complex scene production integrating multiple elements.",
        VIDU_2_0_START_END_720P_description:
          "Generates 720p videos by specifying start and end images. Features high-precision transition functionality for smooth transitions between two scenes.",
        VIDU_2_0_START_END_1080P_description:
          "Start-End functionality's 1080p high-quality version. Generates high-resolution transition videos between start and end images with professional-level transition effects.",
        VIDU_Q1_description:
          "Vidu's high-performance Q1 model. Specialized for image-to-video conversion, providing professional functionality for adding natural and smooth motion to static images.",
        VIDU_Q1_START_END_description:
          "Q1 model's Start-End functionality version. Generates high-quality transition videos specifying start and end images for streamlined video editing.",
      },
      movement: {
        auto: "Auto",
        small: "Small",
        medium: "Medium",
        large: "Large",
      },
      style: {
        general: "General",
        anime: "Anime",
      },
    },
    bytedance: {
      title: "ByteDance",
      description: "[Fast] ByteDance generates natural movements by combining video and audio.",
      model: {
        LATENTSYNC: "LatentSync",
        LATENTSYNC_description:
          "ByteDance's Stable Diffusion-based high-precision lip sync AI. Generates realistic mouth movements and expressions synchronized with audio, achieving natural animation with temporal consistency.",
        SEEDANCE_V1_LITE: "Seedance V1 Lite",
        SEEDANCE_V1_LITE_description:
          "ByteDance's latest text/image-to-video model. Generates high-quality videos with realistic motion from text prompts or images, featuring advanced camera control and motion consistency.",
      },
    },
    sync: {
      title: "Sync",
      description: "[Fast] Sync synchronizes video and audio to create natural lip sync.",
      model: {
        LIPSYNC_190: "LipSync v1.9.0 Beta",
        LIPSYNC_190_description:
          "High-quality lip sync model developed by the creators of Wav2Lip. Generates natural mouth movements and expressions with real-time processing capabilities.",
        LIPSYNC_V2: "LipSync v2",
        LIPSYNC_V2_description:
          "Latest lip sync model. Achieves more precise mouth movements and expression control, efficiently generating professional-quality lip sync.",
      },
    },
    realesrgan: {
      title: "Real-ESRGAN 4K",
      description:
        "Real-ESRGAN applies proven image super-resolution technology to video, enhancing video resolution to create clearer and more detailed footage.",
      model: {
        REALESRGAN: "Real-ESRGAN 4K",
        REALESRGAN_description:
          "Revolutionary model applying Real-ESRGAN's proven image super-resolution technology to video. Enhances low-resolution videos up to 4K quality, naturally restoring details with advanced upscaling technology.",
      },
    },
    google: {
      title: "Google",
      description: "[Fast] Google's video generation AI provides quality and natural movement.",
      model: {
        VEO2: "VEO2",
        VEO2_description:
          "High-performance video generation AI developed by Google's DeepMind. Capable of generating videos up to 4K resolution and 2 minutes long, accurately understanding physics and human movement with reduced hallucinations and comprehension of cinematography terminology.",
        VEO3: "VEO3",
        VEO3_description:
          "Google's latest video generation AI developed as VEO2's successor. Features audio-integrated video generation and lip sync capabilities, achieving revolutionary video production including 8-second conversations, BGM, and sound effects.",
      },
    },
    wan: {
      title: "Wan",
      description:
        "[Medium] Wan is a video generation AI model developed by Alibaba, a major Chinese IT company, capable of generating high-precision videos efficiently.",
      model: {
        V2_1: "Wan v2.1 720P",
        V2_1_description:
          "Latest video generation model developed by Alibaba supporting both text and image inputs. Generates high-quality and natural motion videos at 720p resolution with advanced physics simulation using 14B parameters.",
        V2_1_PRO: "Wan Pro v2.1 1080P",
        V2_1_PRO_description:
          "Pro version of Wan v2.1 supporting 1080p resolution and 30FPS. Capable of higher definition and smoother video generation suitable for professional use.",
        FIRST_TO_LAST: "First To Last Frame 720P",
        FIRST_TO_LAST_description:
          "Specialized model (FLF2V) for smooth transitions between start and end frames. Supports advanced camera movements and achieves cinematic transition effects at 720p quality.",
      },
    },
    pika: {
      title: "Pika",
      description:
        "[Fast] Pika is a video generation AI model that generates high-quality videos from images and supports various aspect ratios.",
      model: {
        V2_2_720P: "Pika v2.2 720P",
        V2_2_1080P: "Pika v2.2 1080P",
        V2_2_SCENES_720P: "Pika Scenes v2.2 720P",
        V2_2_SCENES_1080P: "Pika Scenes v2.2 1080P",
        V2_TURBO_720P: "Pika Turbo v2 720P",
        V2_2_720P_description:
          "Pika's latest 720p video generation model. Supports various aspect ratios (16:9, 9:16, 3:4, etc.) and efficiently executes high-quality image-to-video conversion with up to 10-second video generation capability.",
        V2_2_1080P_description:
          "Pika v2.2's 1080p high-quality version. Capable of clearer and more detailed video output suitable for professional video production.",
        V2_2_SCENES_720P_description:
          "Specialized model for generating integrated scenes from multiple images. Features advanced functionality enabling complex compositional video production at 720p resolution.",
        V2_2_SCENES_1080P_description:
          "Scenes functionality's 1080p version. Generates scene-integrated videos from multiple images at high resolution for more detailed and complex video production.",
        V2_TURBO_720P_description:
          "Pika v2's high-speed generation optimized Turbo model. Significantly reduces generation time while maintaining 720p quality.",
        V2_SWAPS: "Pika Swaps v2",
        V2_SWAPS_description:
          "Specialized functionality for replacing specific objects in existing videos with other objects. Revolutionary object replacement model enabling efficient video editing and creative expression.",
        V2_ADDITIONS: "Pika Additions v2",
        V2_ADDITIONS_description:
          "Functionality for naturally adding new objects or elements to existing videos. Video editing specialized object addition model for efficient content expansion and modification.",
      },
    },
    topazlabs: {
      title: "Topaz Labs",
      description:
        "Provides high-quality video upscaling and frame rate interpolation using next-generation AI technology, supporting up to 4K 60FPS.",
      model: {
        TOPAZ_VIDEO_UPSCALE: "Upscale 4K 60FPS",
        TOPAZ_VIDEO_UPSCALE_description:
          "High-quality video upscaling model using next-generation AI technology. Enhances low-resolution videos up to 4K 60FPS, simultaneously achieving frame interpolation and image quality improvement with industry-leading upscaling technology.",
      },
    },
    framepack: {
      title: "FramePack",
      description:
        "[Fast] FramePack can generate high-quality videos from 5 to 60 seconds, especially suitable for videos with limited movement.",
      model: {
        FRAMEPACK: "Image-to-Video",
        FRAMEPACK_description:
          "Model specialized for long-form video generation from 5-60 seconds. Generates high-quality videos with natural and limited motion from static images, optimal for loop videos and background video production. Efficient long-form video generation model operating on just 6GB VRAM.",
        FRAMEPACK_F1: "F1",
        FRAMEPACK_F1_description:
          "Advanced AI model predicting future frames from past frames in forward direction. Unlike traditional reverse generation, provides larger variance and dynamics, optimized for prompt traveling (continuous changes).",
        FRAMEPACK_FIRST_TO_LAST: "First to Last",
        FRAMEPACK_FIRST_TO_LAST_description:
          "Generates natural transition videos by interpolating between start and end images. FramePack's specialized image transition functionality for smooth transitional video production.",
      },
    },
    hedra: {
      title: "Hedra",
      description:
        "[Fast] Hedra is a lip-sync specialized AI that creates high-quality videos with realistic facial expressions and mouth movements.",
      model: {
        CHARACTER3: "Character 3",
        CHARACTER3_description:
          "Hedra's latest omnimodal model. Integrates image, text, and audio processing to reproduce realistic lip sync, natural facial changes, and full-body movements from images and audio. 3rd generation integrated model specialized for character-based video production.",
      },
    },
  },
  params: {
    title: "Video Settings",
    size: "Video Size",
    upload: "Upload Image",
    uploadFace: "Upload Image (Face)",
    uploadFaceVideo: "Upload Video (Face)",
    uploadVideo: "Upload Video",
    generatedVideo: "Generated Video",
    generatedAudio: "Generated Audio",
    video: "Upload Video",
    audio: "Upload Audio",
    duration: "Video Duration",
    aspect: "Aspect Ratio",
    aspectTooltip:
      "When generating a video from an image, the original image may be stretched, cropped, or resized by the model.",
    loop: "Loop",
    loopMode: "Loop Mode",
    style: "Style",
    resolution: "Resolution",
    negativePrompt: "Negative Prompt",
    swap: "Object to Swap",
    movement: "Movement Amplitude",
    guidanceScale: "Guidance Scale",
    guidanceScaleHelp: "Adjusts the balance between video quality and creativity",
    cameraFixed: "Camera Fixed",
    scale: "Scale",
    scaleHelp: "Set so that the long side does not exceed 3840px and the short side does not exceed 2160px",
    syncModel: "Lip Sync Model",
    syncMode: "Sync Mode",
    pingpong: "Ping Pong",
    loopType: "Loop Type",
    bounce: "Bounce",
    cutOff: "Cut Off",
    lipsync190: "LipSync v1.9.0 Beta",
    lipsync180: "LipSync v1.8.0",
    lipsync171: "LipSync v1.7.1",
    inferenceSteps: "Inference Steps",
    inferenceStepsHelp: "Higher values produce more accurate results but take longer to process",
    fps: "FPS",
    fpsHelp: "Sets the target frame rate for the output video",
    generateAudio: "Generate Audio (affects credit consumption)",
    input: {
      label: "Prompt",
      placeholder: "Enter video prompt (English recommended)",
      notRequired: "Prompt is not required for this mode",
      warning: "Note: Videos that violate the policy cannot be generated, and credit is not guaranteed in such cases.",
      error: {
        button: "Having trouble?",
        tooltip: "If errors persist, there may be a problem on the provider side. Please wait and try again later.",
      },
    },
    submit: "Generate Video",
  },
  myVideo: "My Videos",
  processing: "Generating video...\nUsually completes within 5 minutes.",
  sampleVideo: "Sample Videos",
  sampleVideoDescription:
    "NOTE: Sample videos are for demonstration purposes only. Please note that some features may not be available in Tenak AI.",
  reframe: {
    maxDuration: "Reframe: Maximum {{duration}} seconds, Maximum {{maxSize}}",
  },
  error: {
    generate: "Failed to generate the video.\nPlease check for policy violations and try again later.",
    required: {
      image: "Please upload an image.",
      prompt: "Please enter a prompt.",
      onlyLastImage: "First image is required.",
      swap: "Please enter a object to swap.",
      video: "Please upload a video.",
    },
    max: {
      prompt: "Please enter a prompt within 512 characters.",
      resolution: "Video resolution must be 8.29 megapixels (4K equivalent) or lower.",
      videoSize: "Video file size must be 50MB or less.",
      smallVideoSize: "Video file size must be 8MB or less.",
      videoDuration: "Video duration must be {{sec}} seconds or less.",
      audioSize: "Audio file size must be 30MB or less.",
      audioDuration: "Audio duration must be 60 seconds or less.",
      frames: "REALESRGAN cannot process videos with 1000 or more frames.",
      reframeDuration: "For Reframe, video duration must be {{duration}} seconds or less.",
      reframeSize: "For Reframe, video file size must be 100MB or less.",
    },
    processingLimit:
      "Processing limit exceeded. You have {{current}} requests in progress (images and videos combined). Your plan allows up to {{limit}} simultaneous requests.",
  },
  startGenerating: "Your video generation request has been added to the queue.",
  videoMenu: {
    download: "Download",
    delete: "Delete",
    lastFrame: "Generate from Last Frame",
  },
  extend: {
    title: "Extend Video",
    description: "Extend the beginning and end of the video to generate a longer video.",
    startFrame: "Start Frame (Optional)",
    endFrame: "End Frame (Optional)",
    sourceVideo: "Original Video",
    continue: "Extend in the same direction",
    before: "Extend in the opposite direction",
    extendable: "This model supports the extension function.",
  },
  message: {
    deleted: "Video has been deleted.",
  },
  concepts: "Camera Concepts",
  cameraMovementPreset: {
    icon: "Camera Movement Preset",
    description: "Click to add camera movement to the prompt.",
    title: "Camera Movement",
    warning: "NOTE: Camera movements may not be reflected in some models.",
    concept: {
      truck_left: "Truck Left",
      pan_right: "Pan Right",
      pedestal_down: "Pedestal Down",
      low_angle: "Low Angle",
      pedestal_up: "Pedestal Up",
      selfie: "Selfie",
      pan_left: "Pan Left",
      roll_right: "Roll Right",
      zoom_in: "Zoom In",
      over_the_shoulder: "Over The Shoulder",
      orbit_right: "Orbit Right",
      orbit_left: "Orbit Left",
      static: "Static",
      tiny_planet: "Tiny Planet",
      high_angle: "High Angle",
      bolt_cam: "Bolt Cam",
      dolly_zoom: "Dolly Zoom",
      overhead: "Overhead",
      zoom_out: "Zoom Out",
      handheld: "Handheld",
      roll_left: "Roll Left",
      pov: "POV",
      aerial_drone: "Aerial Drone",
      push_in: "Push In",
      crane_down: "Crane Down",
      truck_right: "Truck Right",
      tilt_down: "Tilt Down",
      elevator_doors: "Elevator Doors",
      tilt_up: "Tilt Up",
      ground_level: "Ground Level",
      pull_out: "Pull Out",
      aerial: "Aerial",
      crane_up: "Crane Up",
      eye_level: "Eye Level",
    },
    icon_concept: "Camera Concepts",
    title_concept: "Camera Concepts",
    warning_concept:
      "Up to 2 concepts can be selected, but it is recommended to select only one as it may cause distortion or unnatural movement.",
    no_concepts_selected: "No concepts selected",
    movement: {
      // Ray2 movements
      panleft: "Pan Left",
      panright: "Pan Right",
      orbitleft: "Orbit Left",
      orbitright: "Orbit Right",
      craneup: "Crane Up",
      cranedown: "Crane Down",
      moveleft: "Move Left",
      moveright: "Move Right",
      moveup: "Move Up",
      movedown: "Move Down",
      pushin: "Push In",
      pullout: "Pull Out",

      // Hailuo movements
      leftcirclingshot: "Left Circling Shot",
      rightcirclingshot: "Right Circling Shot",
      leftwalkingshot: "Left Walking Shot",
      rightwalkingshot: "Right Walking Shot",
      upwardtilt: "Upward Tilt",
      scenicshot: "Scenic Shot",
      stageshotright: "Stage Shot Right",
      stageshotleft: "Stage Shot Left",
      downwardtilt: "Downward Tilt",
      zoomin: "Zoom In",
      zoomout: "Zoom Out",
      tiltup: "Tilt Up",
      tiltdown: "Tilt Down",
      truckleft: "Truck Left",
      truckright: "Truck Right",
      pedestalup: "Pedestal Up",
      pedestaldown: "Pedestal Down",
      trackingshot: "Tracking Shot",
      shake: "Shake",
      staticshot: "Static Shot",
    },
  },
};
export default junoVideo;
